<template>
  <div
    class="disc rounded-circle text-center d-flex-inline justify-content-center"
    @click="onClick"
    :class="classes"
  >
    <slot></slot>
  </div>
</template>

<script>
const SIZE_SM = "sm";
const SIZE_MD = "md";
const SIZE_LG = "lg";

export default {
  name: "AppDisc",
  props: {
    variant: {
      type: String,
      required: false,
      default: "primary",
    },
    size: {
      type: String,
      required: false,
      default: SIZE_MD,
      validator: value => [SIZE_SM, SIZE_MD, SIZE_LG].indexOf(value) >= 0,
    },
    block: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    classes() {
      const classes = {
        [`disc-${this.variant}`]: true,
        [`bg-${this.variant}`]: true,
      };

      if (!this.block) {
        classes[`disc--size-${this.size}`] = true;
      } else {
        classes[`disc--size-block`] = true;
      }

      return classes;
    },
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style lang="scss" scoped>
.disc {
  display: inline-block;

  &--size-sm {
    width: 1rem;
    height: 1rem;
  }
  &--size-md {
    width: 2rem;
    height: 2rem;
    padding: 0.3rem;
  }
  &--size-lg {
    padding: 0.3rem;
    width: 2.5rem;
    height: 2.5rem;
  }
  &--size-block {
    width: 100%;
    height: 100%;
  }
}
</style>
